import { IconFont } from '@lighthouse/bui'
import styled from 'styled-components'

export const TypeName = styled.div`
    color: var(--color-gray-500);
    font-size: 10px;
    font-weight: var(--font-weight-normal);
    line-height: 20px;
    margin-bottom: 4px;
`

export const FieldList = styled.div`
    /* padding-bottom: 4px; */
`

export const FieldItem = styled.div`
    background: #eceff4;
    border-radius: 4px;
    padding: 4px 8px;
    margin-bottom: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const FieldItemTitle = styled.div<{ color?: string }>`
    color: ${({ color }) => color || 'var(--color-gray-600)'};
    font-size: 12px;
    font-weight: 400;
    margin-left: 4px;
    line-height: 18px;
`

export const Text = styled.span<{ color?: string }>`
    color: ${props => props.color || 'var(--color-gray-600)'};
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
    white-space: pre-wrap;
`
